import * as React from 'react';
import type { PluginExports } from 'graylog-web-plugin/plugin';

import AssistantSidebar from 'ai/sidebar/AssistantSidebar';
import type { WidgetActionType, WidgetMenuActionComponentProps } from 'views/components/widgets/Types';
import WidgetSummaryActionComponent from 'ai/widget-summary/WidgetSummaryActionComponent';
import { AssistantSidebarProvider } from 'ai/sidebar/AssistantSidebarContext';
import AppConfig from 'util/AppConfig';
import AggregationWidget from 'views/logic/aggregationbuilder/AggregationWidget';
import AddContextAction from 'ai/context-field/AddContextAction';
import useWidgetSummaryFeatureToggle from 'ai/widget-summary/useWidgetSummaryFeatureToggle';

const WidgetSummaryWithFeatureToggle = (props: WidgetMenuActionComponentProps) => {
  const featureToggle = useWidgetSummaryFeatureToggle();

  return featureToggle.enabled ? <WidgetSummaryActionComponent {...props} /> : null;
};

const WidgetSummaryAction: WidgetActionType = {
  type: 'widget-summary-action',
  position: 'menu',
  component: WidgetSummaryWithFeatureToggle,
  isHidden: ({ type }) => type !== AggregationWidget.type,
};

const pluginExports: PluginExports = AppConfig.isFeatureEnabled('widget_summary')
  ? {
      'views.elements.aside': [AssistantSidebar],
      'views.widgets.actions': [WidgetSummaryAction, AddContextAction],
      'globalContextProviders': [AssistantSidebarProvider],
    }
  : {};

export default pluginExports;
